import {ACTION_CODE} from './_actionCode';
import {DealTagsService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_DEALTAG';

export async function createDealTag(userData: Record<string, any>, dealTag: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - createDealTag - Start');

        const createDealTagResult = await DealTagsService.createDealTag(userData, dealTag);

        LoggerService.logInfo('Action - createDealTag - End - Success');

        return ResultModel.newSuccessResult(createDealTagResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createDealTag - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la création d‘une banque.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
